<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "MasterBatanganIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
